import { inject, Injectable } from "@angular/core";
import { MaintenanceControllerService, MaintenanceDto } from "../generated";
import { MaintenanceDate } from "../../../model/maintenance-schedule.model";
import { map, Observable } from "rxjs";
import { maintenanceDateMapper } from "../mapper/maintenance/maintenance-dto.mapper";

@Injectable({ providedIn: 'root' })
export class MaintenanceCommonService {
    private maintenanceCommonApiService = inject(MaintenanceControllerService);

    getMaintenance(): Observable<MaintenanceDate | null> {
        return this.maintenanceCommonApiService.getMaintenance().pipe(map(maintenanceDto => maintenanceDateMapper(maintenanceDto as Required<MaintenanceDto>)));
    }
}